// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table[data-v-2cbee6b2] {
  width: 100%;
  border-collapse: collapse;
}
th[data-v-2cbee6b2], td[data-v-2cbee6b2] {
  border: 1px solid #ccc;
  padding: 10px;
  text-align: left;
  vertical-align: top;
  color: var(--2cbee6b2-\\\$getStyles\\.tableFontColor);
}
pre[data-v-2cbee6b2] {
  white-space: pre-wrap;
  word-break: break-word;
  font-family: monospace;
  margin: 0;
  color: var(--2cbee6b2-\\\$getStyles\\.tableFontColor);
}
.debug-section[data-v-2cbee6b2] {
  margin-left: 20px;
  margin-right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/pages/Error.vue","webpack://./Error.vue"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,yBAAA;ACDF;ADIA;EACE,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,kDAAA;ACDF;ADIA;EACE,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,SAAA;EACA,kDAAA;ACDF;ADIA;EACE,iBAAA;EACA,kBAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth, td {\n  border: 1px solid #ccc;\n  padding: 10px;\n  text-align: left;\n  vertical-align: top;\n  color: v-bind(\"$getStyles.tableFontColor\");\n}\n\npre {\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-family: monospace;\n  margin: 0;\n  color: v-bind(\"$getStyles.tableFontColor\");\n}\n\n.debug-section {\n  margin-left: 20px;\n  margin-right: 20px;\n}\n","table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth, td {\n  border: 1px solid #ccc;\n  padding: 10px;\n  text-align: left;\n  vertical-align: top;\n  color: v-bind(\"$getStyles.tableFontColor\");\n}\n\npre {\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-family: monospace;\n  margin: 0;\n  color: v-bind(\"$getStyles.tableFontColor\");\n}\n\n.debug-section {\n  margin-left: 20px;\n  margin-right: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
